export const formatProntuarioSessionDate = (
	selectedDate?: string | Date | null,
): string => {
	if (!selectedDate) return '—';

	const date = new Date(selectedDate);
	if (Number.isNaN(date.getTime())) return '—';

	return date.toLocaleString('pt-BR', {
		day: '2-digit',
		month: '2-digit',
		year: 'numeric',
		hour: '2-digit',
		minute: '2-digit',
	});
};
